import { useLocation } from 'react-router-dom';
import english from '../../content/catalogue.json';
import translated from '../../content/catalogue.th.json';
import messages from '../../content/catalogue-ui.th.json';
import { isThaiPath } from '../../content/locales';
export function useCatalogueLocale() {
 const thai = isThaiPath(useLocation().pathname);
 const data = thai ? translated : english;
 const prefix = thai ? '/th' : '';
 const t = (text: string) => thai ? (messages as Record<string, string>)[text] || text : text;
 const industryName = (id: string) => data.industries.find(industry => industry.id === id)?.name || '';
 const appCount = (id: string) => data.apps.filter(app => app.industry === id).length;
 const byId = (id: string) => data.apps.find(app => app.id === id)!;
 const searchText = (id: string) => [english, translated].flatMap(catalogue => {
  const app = catalogue.apps.find(item => item.id === id)!;
  return [app.name, app.description, app.input, app.output, app.keywords, catalogue.industries.find(industry => industry.id === app.industry)?.name || ''];
 }).join(' ').toLowerCase();
 return { thai, data, prefix, t, industryName, appCount, byId, searchText };
}
